import { createContext } from "react";

const UserDataContext = createContext(null);

export default UserDataContext;